// @flow
"use strict";

import React, {
  Component,
  Fragment,
  PropsWithChildren,
  useState,
  useEffect,
} from "react";
import { connect } from "react-redux";
import Navigation from "./Navigation";
import Spinner from "../Common/Components/spinner";
import DotLoader from "../Common/Components/dots";
import {
  loginSelector,
  loadingLoginSelector,
  errorLoginSelector,
} from "./Slice";
import { useSelector } from "react-redux";
import { loginTest, login, logout } from "./Slice";

import { useAppDispatch } from "./store.hooks";
interface LoginProps {}

const ppLogoStyle = { width: "81px", height: "29px" };
const Login = (propsArgs: PropsWithChildren<LoginProps>) => {
  const args = {
    ...{ id: "" },
    ...propsArgs,
  };

  const [user, setUser] = useState<string>("");
  const [pass, setPass] = useState<string>("");
  const [pending, setPending] = useState<boolean>(false);
  const [loggedIn, updateLoggedIn] = useState<boolean>(false);
  const [error, updateError] = useState<string>("");
  const [buffer, updateBuffer] = useState(true);

  const authLoadState = useSelector(loadingLoginSelector);
  const authResponse = useSelector(loginSelector);
  const errorMessage = useSelector(errorLoginSelector);

  const stopBuffer = () => {
    updateBuffer(false);
  };
  useEffect(() => {
    setTimeout(stopBuffer, 1000);
  }, [authLoadState]);
  useEffect(() => {
    updateLoggedIn(authResponse);
  }, [authResponse]);
  useEffect(() => {
      if (authLoadState == "pending") {
      setPending(true);
      updateError("");
    } else {
      setPending(false);
    }
  }, [authLoadState]);
  useEffect(() => {
    updateError(errorMessage);
  }, [errorMessage]);

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch<any>(loginTest());
  }, []);

  const logout_ = () => {
    dispatch<any>(logout());
  };
  const login_ = () => {
    updateBuffer(false);
      dispatch<any>(login({username: user, password: pass,domain:"" }));
  };

  const renderContent = () => {
    let btnValue: any = "Log in";
    if (pending) btnValue = <DotLoader />;
    return (
      <div className="pp-login">
        <div className="pp-login-box">
          <h3>LOGIN</h3>

          <div className="pp-form-group">
            <label className="pp-login-label">Username</label>
            <input
              value={user}
              onChange={(e) => {
                setUser(e.target.value);
              }}
              type="text"
              className="form-control"
              name="username"
              placeholder="Username"
              required={true}
            />
          </div>
          <div className="pp-form-group">
            <label className="pp-login-label">Password</label>
            <input
              value={pass}
              onChange={(e) => {
                setPass(e.target.value);
              }}
              type="password"
              className="form-control"
              name="password"
              placeholder="Password"
              required={true}
            />
          </div>
          <div className="pp-form-group" style={{ color: "red" }}>
            {error}
          </div>
          <button
            type="submit"
            className=" btn-primary pp-login-button"
            onClick={() => {
              login_();
            }}
          >
            {" "}
            {btnValue}
          </button>
        </div>
        <img src="/assets/img/login-image.png" />
      </div>
    );
  };
  if (!loggedIn && !buffer) {
    return (
      <Fragment>
        <div className="pp-login-page">
          <div className="navBar">
            <img src="/assets/img/prima.png" style={ppLogoStyle} />
            <p
              className="pp-header-text pp-unselectable"
              style={{
                color: "white",
                fontWeight: "bold",
                fontSize: "17px",
              }}
            >
              {" "}
              <span> </span>
              <span style={{ color: "#4fb9ff" }}>FLEET MANAGEMENT</span>
            </p>
            <div></div>
          </div>
          <div className="pp-login-content">{renderContent()} </div>
        </div>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Navigation logOut={logout_} />
      {args.children}
    </Fragment>
  );
};

export default Login;
